import { useMemo } from "react";
import { AuthUser } from "@aws-amplify/auth";

export const useReverseUserId = (user: AuthUser) =>
  useMemo(
    () => user?.userId?.replace("-", "").split("")?.reverse()?.join(""),
    [user],
  );
